module.exports = __webpack_public_path__ + "img/mobilemain.265fcfbc.png";